export default class BomBatchModel {
  constructor () {
    this.rowNum = null
    this.순위 = null
    this.차종 = null
    this.품번 = null
    this.납입품번 = null
    this.품명 = null
    this.수량 = null
    this.품목유형 = null
    this.자재유형 = null
    this.공정유형 = null
    this.재질 = null
    this.단위 = null
    this.구매단위 = null
    this.변환배율 = 1.0
    this.거래처코드 = null
    this.납품처코드 = null
    this.담당부서 = null
    this.라인코드 = null
    this.도급 = null
    this.외주가공비 = null
    this.구입가 = null
    this.판매가 = null
    this.파레트적재량 = null
    this.cvt = null
    this.두께 = null
    this.가로 = null
    this.세로 = null
    this.net = null
  }
}
